export const ADD_WELLS_ALREADY_EXISTS_IN_DISPLAY_PANEL = "API # already exists"
export const ADD_WELLS_API_INCORRECT_FORMAT = "Enter a valid API #"
